import { pushDataLayer } from './dataLayer'

export default function trackCategoryView(categoryData) {
  if (categoryData) {
    pushDataLayer({
      dataLayer: {
        pageType: categoryData.datatype,
        categoryTitle: categoryData.category_title,
      },
    })
  }
}
